import React from 'react';
import styled from 'styled-components';
import { gutter } from '../../styles/mixins';
import { m20 } from '../../styles/typography';

const Host = styled.div`
  margin-bottom: ${gutter(4)};
  > * {
    margin-right: ${gutter(4)};
  }
`;

const Title = styled.h2`
  ${m20};
  margin-bottom: ${gutter(1)};
`;
interface LegoGroupProps {
  title: string;
  children: React.ReactNode;
}

export const LegoGroup = ({ title, children }: LegoGroupProps) => {
  return (
    <Host>
      <Title>{title}</Title>
      {children}
    </Host>
  );
};
